import axios from "axios";
import api from "../scripts/api.js";

export default {
	state: {
		navbar: {
			current: 1,
			list: [
				{
					id: 1,
					quantity: 6,
					name: "Объекты",
					feature: 3,
					isActive: true,
				},
				{
					id: 2,
					quantity: 24,
					name: "Задачи",
					feature: "2089",
					isActive: false,
				},
				{
					id: 3,
					quantity: 18,
					name: "Мои задачи",
					feature: "2089",
					isActive: false,
				},
				{
					id: 4,
					quantity: 11,
					name: "Исполнители",
					feature: "Airwet",
					isActive: false,
				},
				{
					id: 5,
					quantity: 11,
					name: "Заявки",
					feature: "Airwet",
					isActive: false,
				},
			],
			search: {
				query: null,
				validation: false,
				result: null,
			},
		},
		control: {
			limits: {},
			filterCategory: {},
			filterState: {},
			filterType: {},
		},
		dealers: [],
		regions: [],
		proSystems: [],
		objects: {
			sort: {
				param: null,
				order: null,
			},
			list: [],
		},
		tasks: {
			sort: {
				param: "date",
				order: "asc",
			},
			list: [],
		},
		personal: {
			sort: {
				param: "date",
				order: "asc",
			},
			list: [],
		},
		staff: {
			sort: {
				param: "date",
				order: "asc",
			},
			list: [],
		},
		applications: {
			sort: {
				param: "date",
				order: "asc",
			},
			list: [],
		},
	},
	getters: {
		getSystemsNavbar: (state) => state.navbar,
		getSystemsControl: (state) => state.control,
		getSystemsProSystems: (state) => state.proSystems,
		getSystemsDealers: (state) => state.dealers,
		getSystemsRegions: (state) => state.regions,
		getSystemsObjects: (state) => state.objects,
		getSystemsTasks: (state) => state.tasks,
		getSystemsPersonal: (state) => state.personal,
		getSystemsStaff: (state) => state.staff,
		getSystemsApplications: (state) => state.applications,
	},
	mutations: {
		updateSystemsNavbar(state, payload) {
			state.navbar = {
				current: 1,
				list: [
					{
						id: 1,
						quantity: payload?.meta?.pagination?.total || 0,
						name: "Объекты",
						feature: payload?.data?.length || 0,
						isActive: true,
					},
					/* {
						id: 2,
						quantity: 24,
						name: "Задачи",
						feature: "2089",
						isActive: false,
					}, */
					/* {
						id: 3,
						quantity: 18,
						name: "Мои задачи",
						feature: "2089",
						isActive: false,
					}, */
					/* {
						id: 4,
						quantity: 11,
						name: "Исполнители",
						feature: "Airwet",
						isActive: false,
					}, */
					/* {
            id: 5,
            quantity: 11,
            name: 'Заявки',
            feature: 'Airwet',
            isActive: false,
          }, */
				],
				search: {
					query: null,
					validation: false,
				},
			};
		},
		updateSystemsControl(state) {
			let filterCategoryItems = [
				{
					id: 1,
					name: "all",
					title: "Все",
				},
				{
					id: 2,
					name: "favorite",
					title: "Избранные",
				},
			];

			let filterTypesItems = [
				{
					id: 0,
					name: "all",
					title: "Все",
				},
				{
					id: 1,
					name: "home",
					title: "Индивидуальные",
				},
				{
					id: 2,
					name: "pro",
					title: "Централизованные",
				},
			];

			let filterStateItems = [
				{
					id: 0,
					name: "all",
					title: "Все",
				},
				{
					id: 1,
					name: "active",
					title: "Работает",
				},
				{
					id: 2,
					name: "inactive",
					title: "Отключена",
				},
				{
					id: 3,
					name: "disabled",
					title: "Выключена",
				},
				{
					id: 4,
					name: "offline",
					title: "Не в сети",
				},
				{
					id: 5,
					name: "vacation",
					title: "Отпуск",
				},
				{
					id: 6,
					name: "error",
					title: "Ошибка",
				},
			];

			let filterCategory = filterCategoryItems.find(
				(item) => item.name == localStorage.getItem("systems__objects-filterCategory")
			);

			let filterType = filterTypesItems.find(
				(item) => item.name == localStorage.getItem("systems__objects-filterType")
			);

			let filterState = filterStateItems.find(
				(item) => item.name == localStorage.getItem("systems__objects-filterState")
			);

			state.control.filterCategory = {
				type: "simple",
				name: "filter_category",
				value: filterCategory ? filterCategory.title : "Все",
				error: null,
				status: "default",
				categories: filterCategoryItems,
			};

			state.control.filterType = {
				type: "simple",
				name: "filter_type",
				value: filterType ? filterType.title : "Тип системы",
				error: null,
				status: "default",
				categories: filterTypesItems,
			};

			state.control.filterState = {
				type: "simple",
				name: "filter_state",
				value: filterState ? filterState.title : "Состояние системы",
				error: null,
				status: "default",
				categories: filterStateItems,
			};
		},

		updateSystemsProSystems(state, payload) {
			if (payload?.length) {
				state.proSystems = payload.map((item) => {
					let obj = {
						id: item.id,
						name: "system",
						title: item.name,
					};
					return obj;
				});
			}
		},
		updateSystemsDealers(state, payload) {
			if (payload?.length) {
				state.dealers = payload.map((item) => {
					let obj = {
						id: item.id,
						name: "dealer",
						title: item.name,
					};
					return obj;
				});
			}
		},
		updateSystemsRegions(state, payload) {
			if (payload?.length) {
				state.regions = payload.map((item) => {
					let obj = {
						id: item.id,
						name: "region",
						title: item.name,
					};

					return obj;
				});
			}
		},
		updateSystemsObjects(state, payload) {
			state.objects.list = payload;

			state.objects.list.forEach((system) => {
				system.max_hum = 1;

				if (system.state === "active") {
					system.state = {
						value: "active",
						text: "Работает",
					};
				}

				if (system.state === "inactive") {
					system.state = {
						value: "inactive",
						text: "Отключена",
					};
				}

				if (system.state === "disabled") {
					system.state = {
						value: "disabled",
						text: "Выключена",
					};
				}

				if (system.state === "offline") {
					system.state = {
						value: "offline",
						text: "Не в сети",
					};
				}

				if (system.state === "vacation") {
					system.state = {
						value: "vacation",
						text: "Отпуск",
					};
				}

				if (system.state === "error") {
					system.state = {
						value: "error",
						text: "Ошибка",
					};
				}
			});
		},
		updateSystemsTasks(state) {
			state.tasks.list = [
				{
					id: 1,
					period: "18-12-2021",
					number: "A-012-37-22-12-2021",
					kind: {
						name: "error",
						text: "Прокладка сетей",
					},
					contract: "9800-21-12-2021",
					type: "Квартира",
					address: "Новокуйбышевск, ул. Перестройческая 23, 78",
					executor: "Авелович А.",
				},
			];
		},
		updateSystemsPersonal(state) {
			state.personal.list = [
				{
					id: 1,
					period: "18-12-2021",
					number: "A-012-37-22-12-2021",
					kind: {
						name: "success",
						text: "Ошибка",
					},
					contract: "9800-21-12-2021",
					type: "Дом",
					address: "Новокуйбышевск, ул. Перестройческая 23, 78",
					status: {
						name: "done",
						text: "22-12-2021 Выполнено",
					},
				},
				{
					id: 2,
					period: "18-12-2021",
					number: "A-012-37-22-12-2021",
					kind: {
						name: "error",
						text: "Ошибка",
					},
					contract: "9800-21-12-2021",
					type: "Квартира",
					address: "Санкт-Петербург, ул.Перестройческая 23, 78",
					status: {
						name: "process",
						text: "22-12-2021",
					},
				},
			];
		},
		updateSystemsStaff(state) {
			state.staff.list = [
				{
					id: 1,
					company: "Airwet",
					executor: "Жоворьев Руслан",
					type: {
						name: "default",
						text: "продажи",
					},
					city: "Екатеринбург",
					phone: "+7 (900) 18 19 997",
					email: "emilyanov.eng@airwet.ru",
				},
				{
					id: 2,
					company: "Airwet Самара",
					executor: "Емельянов Владислав Яковлевич",
					type: {
						name: "pro",
						text: "инженер",
					},
					city: "Самара",
					phone: "+7 (912) 34 43 765",
					email: "emilyanov.eng@airwet.ru",
				},
			];
		},
		updateSystemsApplications(state) {
			state.applications.list = [
				{
					id: 1,
					date: "18.05.2022",
					contract: "АН-123456",
					type: {
						name: "data",
						text: "Изменение данных",
					},
					comment: "Ошибка в фамилии пользователя",
					status: "На рассмотрении",
				},
				{
					id: 2,
					date: "22.10.2022",
					contract: "АА-654321",
					type: {
						name: "data",
						text: "Изменение данных",
					},
					comment: "Ошибка в фамилии пользователя",
					status: "На рассмотрении",
				},
			];
		},

		sortSystemsTable(state, payload) {
			let order = "";

			if (payload.order === null) payload.order = "asc";
			payload.order === "asc" ? (order = "desc") : (order = "asc");

			if (payload.tab === "objects") {
				if (payload.param === "date") {
					if (payload.order === "asc") {
						state.objects.list.sort((a, b) => b.contract.date - a.contract.date);
					}
					if (payload.order === "desc") {
						state.objects.list.sort((a, b) => a.contract.date - b.contract.date);
					}
				}

				if (payload.param === "type") {
					state.objects.list.sort((a, b) => {
						let typeA = a.type.toLowerCase();
						let typeB = b.type.toLowerCase();

						if (payload.order === "asc") {
							if (typeA < typeB) return -1;
							if (typeA > typeB) return 1;
							return 0;
						}

						if (payload.order === "desc") {
							if (typeA > typeB) return -1;
							if (typeA < typeB) return 1;
							return 0;
						}
					});
				}

				if (payload.param === "address") {
					state.objects.list.sort((a, b) => {
						let addressA = a.address.toLowerCase();
						let addressB = b.address.toLowerCase();

						if (payload.order === "asc") {
							if (addressA < addressB) return -1;
							if (addressA > addressB) return 1;
							return 0;
						}

						if (payload.order === "desc") {
							if (addressA > addressB) return -1;
							if (addressA < addressB) return 1;
							return 0;
						}
					});
				}

				if (payload.param === "state") {
					state.objects.list.sort((a, b) => {
						let stateA = a.state.text.toLowerCase();
						let stateB = b.state.text.toLowerCase();

						if (payload.order === "asc") {
							if (stateA < stateB) return -1;
							if (stateA > stateB) return 1;
							return 0;
						}

						if (payload.order === "desc") {
							if (stateA > stateB) return -1;
							if (stateA < stateB) return 1;
							return 0;
						}
					});
				}
			}

			state[payload.tab].sort.param = payload.param;
			state[payload.tab].sort.order = order;
		},
		changeSystemsObjectsSearch(state, payload) {
			if (payload.length > 2) state.navbar.search.validation = true;
			else state.navbar.search.validation = false;

			state.navbar.search.query = payload;
		},
		clearSystemsObjectsSearch(state, payload) {
			if (payload) {
				state.navbar.search.result = payload;
				state.navbar.search.validation = false;
			} else {
				state.navbar.search.result = null;
				state.navbar.search.query = null;
				state.navbar.search.validation = false;
			}
		},
		setSystemsActiveNavbarItem(state, item) {
			state.navbar.list.forEach((element) => (element.isActive = false));
			state.navbar.list.forEach((element) => {
				if (element.id == item.id) {
					element.isActive = true;
					state.navbar.current = +item.id;
				}
			});
		},

		updateSystemsObjectsCommonSocket(state, payload) {
			//console.log(payload);

			state.objects.list.forEach((object) => {
				payload.forEach((item) => {
					if (object.id == item.id) {
						if (item.state) {
							object.state = item.state;

							if (object.state === "active") {
								object.state = {
									value: "active",
									text: "Работает",
								};
							}

							if (object.state === "inactive") {
								object.state = {
									value: "inactive",
									text: "Отключена",
								};
							}

							if (object.state === "disabled") {
								object.state = {
									value: "disabled",
									text: "Выключена",
								};
							}

							if (object.state === "offline") {
								object.state = {
									value: "offline",
									text: "Не в сети",
								};
							}

							if (object.state === "vacation") {
								object.state = {
									value: "vacation",
									text: "Отпуск",
								};
							}

							if (object.state === "error") {
								object.state = {
									value: "error",
									text: "Ошибка",
								};
							}
						}
					}
				});
			});
		},

		clearSystemsState(state) {
			state.objects.list = [];
			state.tasks.list = [];
			state.personal.list = [];
			state.staff.list = [];
		},
	},
	actions: {
		fetchSystemsObjects(context) {
			context.commit("showPreloader");

			api.getSystems({
				start: this.state.common.pagination.start,
				limit: this.state.common.pagination.limit,
				filterCategory: localStorage.getItem("systems__objects-filterCategory") || "all",
				filterType: localStorage.getItem("systems__objects-filterType") || "all",
				filterState: localStorage.getItem("systems__objects-filterState") || "all",
				query: this.state.navbar?.search?.query || "",
				success: (response) => {
					context.commit("updateSystemsObjects", response.data.data);
					context.commit("updateSystemsNavbar", response.data);
					context.commit("updateSystemsControl", response.data);
					context.commit("updateSystemsApplications");
					context.commit("updatePagination", response.data.meta);
					context.commit("hidePreloader");
				},
				error: (error) => {
					context.commit("handleError", error);
				},
			});
		},
		fetchSystemsProSystems(context) {
			api.getProSystems({
				success: (response) => {
					context.commit("updateSystemsProSystems", response.data.data);
				},
				error: (error) => {
					context.commit("handleError", error);
				},
			});
		},
		fetchSystemsRegions(context) {
			api.getRegions({
				success: (response) => {
					context.commit("updateSystemsRegions", response.data.data);
				},
				error: (error) => {
					context.commit("handleError", error);
				},
			});
		},
		fetchSystemsDealers(context) {
			api.getDealers({
				success: (response) => {
					context.commit("updateSystemsDealers", response.data.data);
				},
				error: (error) => {
					context.commit("handleError", error);
				},
			});
		},

		/* TODO: */
		editSystemsObject(context, payload) {
			context.commit("showPreloader");

			let dealer = context.state.dealers.find((item) => item.title === payload.dealer);
			let dealerID = 1;

			if (dealer) dealerID = dealer.id;

			let system = {
				data: {
					type: payload.type,
					//control_channels: payload.control_channels,
					address: payload.address,
					name: payload.name,
					dealer: {
						set: [dealerID],
					},
					from_users: {
						connect: [payload.user],
					},
				},
			};

			let contract = {
				data: {
					value: payload.contract,
					phone: payload.phone,
					date: payload.date,
					from_system: payload.system,
				},
			};

			axios
				.put(`${this.state.common.api}/updateSystem/${payload.system}`, system, this.state.common.headers)
				.then(() => {
					axios
						.put(`${this.state.common.api}/contracts/${payload.contractID}`, contract, this.state.common.headers)
						.then(() => {
							if (payload.type === "pro_home") {
								axios
									.get(
										`${this.state.common.api}/getSystem/${payload.pro_system_id}`,
										this.state.common.headers
									)
									.then((response) => {
										context.commit("updateSystemNavbar", response.data);
										context.commit("updateSystemChildren", response.data);
										context.commit("hidePreloader");
									})
									.catch((error) => context.commit("handleError", error));
							} else {
								axios
									.get(
										`${this.state.common.api2}/getSystems?pagination[start]=${this.state.common.pagination.start}&pagination[limit]=${this.state.common.pagination.limit}`,
										this.state.common.headers
									)
									.then((response) => {
										context.commit("updateSystemsObjects", response.data.data);
										context.commit("hidePreloader");
									});
							}
						});
				})
				.catch((error) => context.commit("handleError", error));
		},
		deleteSystemsObject(context, payload) {
			context.commit("showPreloader");

			axios
				.delete(`${this.state.common.api}/systems/${payload.system}`, this.state.common.headers)
				.then(() => {
					if (payload.page) {
						axios
							.get(`${this.state.common.api}/getSystem/${payload.from_system}`, this.state.common.headers)
							.then((response) => {
								context.commit("updateSystemNavbar", response.data);
								context.commit("updateSystemChildren", response.data);
								context.commit("hidePreloader");
							})
							.catch((error) => context.commit("handleError", error));
					} else {
						axios
							.get(
								`${this.state.common.api}/systems/?populate[0]=contract,from_users&filters[type][$in][0]=pro&filters[type][$in][1]=home&filters[isDemo][$eq]=false,pro&filters[isDemo][$eq]=false&pagination[start]=${this.state.common.pagination.start}&pagination[limit]=${this.state.common.pagination.limit}&sort=id:desc`,
								this.state.common.headers
							)
							.then((response) => {
								context.commit("updateSystemsObjects", response.data.data);
								context.commit("hidePreloader");
							});
					}
				})
				.catch((error) => context.commit("handleError", error));
		},

		newCreateSystemsObject(context, payload) {
			context.commit("showPreloader");

			let system = {
				data: {
					type: payload.type,
					name: payload.name,
					dealer: payload.dealer,
					region: payload.region,
					city: payload.city,
					street: payload.street,
					home: payload.home,
					apartment: payload.apartment,
					pro_system_id: payload.pro_system_id,
					comment: payload.comment,
				},
			};

			api.createSystem({
				data: system,
				success: () => {
					if (payload.type == "pro_home") {
						api.getSystem({
							id: payload.pro_system_id,
							success: (response) => {
								console.log(response.data);

								context.commit("updateSystemChildren", response.data, { root: true });

								//context.commit("updateSystemChildren", response.data);

								context.commit("hidePreloader");
							},
							error: (error) => {
								context.commit("handleError", error);
							},
						});
					} else {
						api.getSystems({
							start: this.state.common.pagination.start,
							limit: this.state.common.pagination.limit,
							filterCategory: localStorage.getItem("systems__objects-filterCategory") || "all",
							filterType: localStorage.getItem("systems__objects-filterType") || "all",
							filterState: localStorage.getItem("systems__objects-filterState") || "all",
							query: this.state.navbar?.search?.query || "",
							success: (response) => {
								context.commit("updateSystemsObjects", response.data.data);
								context.commit("updateSystemsNavbar", response.data);
								context.commit("updateSystemsControl", response.data);
								context.commit("updateSystemsApplications");
								context.commit("updatePagination", response.data.meta);
								context.commit("hidePreloader");
							},
							error: (error) => {
								context.commit("handleError", error);
							},
						});
					}
				},
				error: (error) => {
					context.commit("handleError", error);
				},
			});
		},
		newEditSystemsObject(context, payload) {
			context.commit("showPreloader");

			let system = {
				data: {
					type: payload.type,
					name: payload.name,
					dealer: payload.dealer,
					geo_data: {
						id: payload.id,
						region: payload.region,
						city: payload.city,
						street: payload.street,
						home: payload.home,
						apartment: payload.apartment,
						pro_system_id: payload.pro_system_id,
						comment: payload.comment,
					},
				},
			};

			api.editSystem({
				id: payload.system,
				data: system,
				success: () => {
					api.getSystems({
						start: this.state.common.pagination.start,
						limit: this.state.common.pagination.limit,
						filterCategory: localStorage.getItem("systems__objects-filterCategory") || "all",
						filterType: localStorage.getItem("systems__objects-filterType") || "all",
						filterState: localStorage.getItem("systems__objects-filterState") || "all",
						query: this.state.navbar?.search?.query || "",
						success: (response) => {
							context.commit("updateSystemsObjects", response.data.data);
							context.commit("updateSystemsNavbar", response.data);
							context.commit("updateSystemsControl", response.data);
							context.commit("updateSystemsApplications");
							context.commit("updatePagination", response.data.meta);
							context.commit("hidePreloader");
						},
						error: (error) => {
							context.commit("handleError", error);
						},
					});
				},
				error: (error) => {
					context.commit("handleError", error);
				},
			});
		},

		searchSystemsObjects(context, payload) {
			context.commit("showPreloader");

			api.getSystems({
				start: this.state.common.pagination.start,
				limit: this.state.common.pagination.limit,
				filterCategory: localStorage.getItem("systems__objects-filterCategory") || "all",
				filterType: localStorage.getItem("systems__objects-filterType") || "all",
				filterState: localStorage.getItem("systems__objects-filterState") || "all",
				query: payload || "",
				success: (response) => {
					context.commit("updateSystemsObjects", response.data.data);
					context.commit("clearSystemsObjectsSearch", response.data.data);
					context.commit("updatePagination", response.data.meta);
					context.commit("hidePreloader");
				},
				error: (error) => {
					context.commit("handleError", error);
				},
			});
		},
		clearSystemsObjects(context) {
			context.commit("showPreloader");

			if (context.state.navbar.search.result) {
				api.getSystems({
					start: this.state.common.pagination.start,
					limit: this.state.common.pagination.limit,
					filterCategory: localStorage.getItem("systems__objects-filterCategory") || "all",
					filterType: localStorage.getItem("systems__objects-filterType") || "all",
					filterState: localStorage.getItem("systems__objects-filterState") || "all",
					query: this.state.navbar?.search?.query || "",
					success: (response) => {
						context.commit("updateSystemsObjects", response.data.data);
						context.commit("clearSystemsObjectsSearch");
						context.commit("updatePagination", response.data.meta);
						context.commit("hidePreloader");
					},
					error: (error) => {
						context.commit("handleError", error);
					},
				});
			} else {
				context.commit("clearSystemsObjectsSearch");
				context.commit("hidePreloader");
			}
		},
		addSystemToFavorite(context, payload) {
			console.log(context);
			console.log(payload);
		},

		changeFilterSystemsObjects(context) {
			context.commit("showPreloader");

			api.getSystems({
				start: this.state.common.pagination.start,
				limit: this.state.common.pagination.limit,
				filterCategory: localStorage.getItem("systems__objects-filterCategory") || "all",
				filterType: localStorage.getItem("systems__objects-filterType") || "all",
				filterState: localStorage.getItem("systems__objects-filterState") || "all",
				query: this.state.navbar?.search?.query || "",
				success: (response) => {
					context.commit("updateSystemsObjects", response.data.data);
					context.commit("updateSystemsNavbar", response.data);
					context.commit("updateSystemsControl", response.data);
					context.commit("updateSystemsApplications");
					context.commit("updatePagination", response.data.meta);
					context.commit("hidePreloader");
				},
				error: (error) => {
					context.commit("handleError", error);
				},
			});
		},
	},
};
